import { Command } from 'commander';
import { ConfigService } from '../../services/config.service.js';
import { ImageService } from '../../services/image.service.js';
import { ValidationError } from '../../errors/index.js';

export function createImageInfoCommand(): Command {
    return new Command('info')
        .description('Get detailed info about an image')
        .argument('<id>', 'Image ID')
        .action(async (id) => {
            const configService = new ConfigService();
            const config = await configService.load();

            if (!config) {
                throw new ValidationError('Not initialized. Run "jai1 auth" first.');
            }

            const imageService = new ImageService();
            const image = await imageService.getInfo(config, parseInt(id));

            console.log('\n📸 Image Details:\n');
            console.log(`ID:          ${image.id}`);
            console.log(`Model:       ${image.model}`);
            console.log(`Prompt:      ${image.prompt}`);
            console.log(`URL:         ${image.url}`);
            console.log(`Size:        ${(image.contentSize / 1024).toFixed(2)} KB`);
            if (image.width && image.height) {
                console.log(`Dimensions:  ${image.width}x${image.height}`);
            }
            console.log(`Created:     ${new Date(image.createdAt).toLocaleString()}`);

            if (image.metadata) {
                const meta = typeof image.metadata === 'string' ? JSON.parse(image.metadata) : image.metadata;
                if (meta.aspectRatio) {
                    console.log(`Ratio:       ${meta.aspectRatio}`);
                }
                if (meta.negativePrompt) {
                    console.log(`Negative:    ${meta.negativePrompt}`);
                }
                if (meta.seed) {
                    console.log(`Seed:        ${meta.seed}`);
                }
            }
        });
}
